import { computed, toRefs } from 'vue';
import { DateTime } from 'luxon';
import { Article } from '~/types';
import { useDate } from '~/composables/useDate';

export const useArticle = (article: Article.Model) => {
  const {
    author,
    featured_image: featuredImage,
    featured_image_src_set: featuredImageSrcSet,
    id,
    permalink,
    published_at: publishedAt,
    short_description: shortDescription,
    show_author: showAuthor,
    title,
    type,
  } = toRefs(article);

  const authorName = computed<string | undefined>(() => author?.value?.full_name);
  const contentBlocks = computed(() =>
    article?.version_content_blocks ? article.version_content_blocks : article?.content_blocks
  );
  const { articleDate } = useDate(publishedAt?.value);
  const date = computed<DateTime>(() => DateTime.fromISO(publishedAt?.value));

  return {
    articleDate,
    author,
    authorName,
    contentBlocks,
    date,
    featuredImage,
    featuredImageSrcSet,
    id,
    permalink,
    publishedAt,
    shortDescription,
    showAuthor,
    title,
    type,
  };
};
